import React, { useState , useEffect, useRef, useContext} from "react";
import "./ModulePermissions.css";
import AwsServerService from "../../../common/util/AwsServerService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faFile, faUsers, faAngleDown, faAngleRight, faArrowDown, faArrowLeft, faArrowRight, faBackward, faCaretDown, faCaretRight, faCartArrowDown, faSearch } from "@fortawesome/free-solid-svg-icons";
import { Col, Input, Row } from "reactstrap";
import { Checkbox, Popover, Tooltip, Select, message,Modal, Button} from "antd";  
import { canAccess } from "../../../common/util/appUtils";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import SelectDealsModal from "./SelectDealsModal";
import { setAccessContext } from "../../../Context/UserContext";
import { getSocket } from "../../../Socket";
import { AppDataRequired } from '../../../App';
import WorkdrivePermissions from "./WorkdrivePermissions";
const { Option } = Select;

export default function ModulePermissions({isEditProfileAccess, setIsEditProfileAccess, selectedUser, profilesData, fromUserForm}) {
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const [modules, setModules] = useState([]);
  const reduxDispatch = useDispatch();
  const socket = getSocket();
  const [fieldPermissions, setFieldPermissions] = useState([]);
  const [selectedTab, setSelectedTab] = useState("module");
  let userInfo = JSON.parse(localStorage.getItem("userinfo"));
  const permissionsList = ["View", "Create", "Edit", "Delete"];
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [subDropdownOpen, setSubDropdownOpen] = useState({});
  const [selectedProfileId, setSelectedProfileId] = useState(isEditProfileAccess?.Profile?.ROWID);
  const [isFieldChanged, setIsFieldChanged] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFieldModule, setSelectedFieldModule] = useState(null);
  const [moduleEnabled, setModuleEnabled] = useState({});
  const [criteriaModal, setCriteriaModal] = useState(false);
  const [modulesList, setModulesList] = useState([])
  const [subModulesList, setSubModulesList] = useState([])
  const [fieldList, setFieldList] = useState([])
  const [refreshPermissions, setRefreshPermissions] = useState(false);
  const [teamFolders, setTeamFolders] = useState([]);
  
  const fetchTeamFolders = async () => {
    const res = await AwsServerService.fetchTeamFolderData(
      "lvelh71c5a951437d4db18a23bc8628fec5be",
      localStorage.getItem("token")
    );
    const filterData = res.data?.data.filter(
      item =>
        item.attributes.is_partof === true &&
        item.attributes.capabilities?.can_read === true
    );
    setTeamFolders(filterData || []);
  };

  useEffect(()=>{
    AwsServerService.AllModules().then(res =>{
      setModulesList(res.data)
    })
    AwsServerService.GetSubModules().then(res =>{
      setSubModulesList(res.data)
    })
    AwsServerService.AllFields().then(res =>{
      setFieldList(res.data)
    })
  },[]) 
const isInitialRender = useRef(true);
const securityAccess = (moduleName, key) =>{
  const module = accessContext?.modulePermissions?.find(item => item.module_name == "Security Control");
  const modPermission = module?.sub_modules?.find(item => item?.submodule_name == moduleName);
  if (moduleName === "Tasks") {
    const taskPermissionValue = modPermission?.permissions[key];
    if (["View", "Edit", "Trash"].includes(key)) {
      return taskPermissionValue ?? "None";
    }
  }
  return modPermission?.permissions[key] === true;
}
const canAccesSub = (module) =>{
  const perm = canAccess(accessContext, module, "View");
  if(module == "Tasks"){
    return perm == "None" ? false : true;
  }
  return perm;
}
const [selectedData, onSelectedData] = useState([])
 useEffect(()=>{
    if(selectedData && isInitialRender.current == false){
      const modPermissions = modules.map(mod =>{
        if (mod.module_name === "Deals") {
          return {
            ...mod,
            selectFilter: selectedData || []
          };
        }
        return mod;
      });
      
      if(fromUserForm){
        const payload = {
          ...isEditProfileAccess.Profile,
          IS_PERMISSION_OVERRIDEN: true,
          OVERRIDEN_MODULE_PERMISSION: modPermissions,
          MODIFIEDBY  : userInfo.email_id,
          ROWID : selectedUser?.ROWID
        };
        updateUserProfile(payload);
      } else {
      const payload = {
        ...isEditProfileAccess.Profile,
        MODULE_PERMISSIONS: modPermissions,
        MODIFIEDBY: userInfo.email_id,
      };
      updateProfile(payload);
      }
    }
  },[selectedData])

const [userPermissions, setUserPermissions] = useState([]);
const [userPermissionEnabled, setUserPermissionEnabled] = useState(true);
const [userDropdownOpen, setUserDropdownOpen] = useState(false);
const isManageUsersEnabled = userPermissions?.ManageUsers?.enabled;
const isSubordinateOnly =
  isManageUsersEnabled && userPermissions?.ManageUsers?.scope?.["Subordinate Only"];
const disableRoleAndProfile = !isManageUsersEnabled || isSubordinateOnly;

// Effect to auto-disable dependent permissions
useEffect(() => {
  if (!disableRoleAndProfile) return;

  const updated = { ...userPermissions };

  ["Manage Role", "Manage Profile"].forEach((key) => {
    if (key in updated) updated[key] = false;
  });

  setUserPermissions(updated);
  console.log("Updated user 1",updated)
  // AwsServerService.UpdateProfile({
  //   ...isEditProfileAccess.Profile,
  //   USER_PERMISSIONS: updated,
  //   MODIFIEDBY: userInfo.email_id,
  // });
}, [disableRoleAndProfile]);
  useEffect(()=>{ 
  const fetchProfile = async () => {
    try{
    let request = fromUserForm ? AwsServerService.GetUserProfile(selectedUser?.EMAIL_ID) 
                : AwsServerService.GetProfile(selectedProfileId); 
      const res = await request;
      const modulePermission = res.data[0]?.MODULE_PERMISSIONS;
      setModules(modulePermission)
      const enabledModule = modulePermission.reduce((acc, module) => {
        acc[module.module_id] =  module.permissions?.View === true;
        return acc;
      }, {})
      setIsEditProfileAccess({isTrue:true, Profile:res.data[0]})
      setModuleEnabled(enabledModule);
      setFieldPermissions(res.data[0]?.FIELD_PERMISSIONS);
      setUserPermissions(res.data[0]?.USER_PERMISSIONS);
      isInitialRender.current = true;
      onSelectedData(modulePermission?.find(e=>e.module_name == "Deals")?.selectFilter || []);
    } catch (err){
      console.log("Fetch Error:-",err.message)
      message.warning('Failed to fetch profile info!');
    }
  }
    fetchProfile();
  }, [selectedProfileId, refreshPermissions])

  const toggleDropdown = (module) => {
    setDropdownOpen({
      ...dropdownOpen,
      [module]: !dropdownOpen[module],
    });
  };
  const toggleSubDropdown = (subModuleId) => {
    setSubDropdownOpen({
      ...subDropdownOpen,
      [subModuleId]: !subDropdownOpen[subModuleId],
    });
  };
useEffect(() => {
  if (selectedTab === "field" && modules.length > 0) {
    let ID = null;
    let name = null;
    const firstViewModule = modules.find(e => e?.permissions?.View);
    if(firstViewModule){
      ID = firstViewModule.module_id;
      name = firstViewModule.module_name;
    }
    setSelectedFieldModule({
      type: "module",
      id: ID,
      name: name
    });
  }
}, [selectedTab, modules]);
const filteredModules = modules.filter(module =>
  module.module_name.toLowerCase().includes(searchTerm.toLowerCase())
);
  const updateProfile = (payload, isField) => {
    AwsServerService.UpdateProfile(payload).then((res)=>{
      const rows = res?.data?.data;
      socket.emit("access-updated","");
      reduxDispatch(
        setAccessContext({
          ...accessContext,
          modulePermissions : payload?.MODULE_PERMISSIONS,
          fieldPermissions : payload?.FIELD_PERMISSIONS,
          userPermission : payload?.USER_PERMISSIONS,
        })
      )
      if(rows?.affectedRows > 0 && isField){
          setSaveMessage("Field Permissions Saved Successfully!!");
      }
    })
  }
  const updateUserProfile = (payload, isField) => {
    AwsServerService.UpdateUserProfile(payload).then((res)=>{
      const rows = res?.data?.data;
      if(rows?.affectedRows > 0 && isField){
          setSaveMessage("Field Permissions Saved Successfully!!");
      }
    })
  }
const getTaskPermissionValue = (value, options) => {
  return options.includes(value) ? value : "None";
};
const TASK_PERMISSION_CONFIG = {
  View: ["All", "Related", "None"],
  Edit: ["All", "Both", "Added", "Owned", "None"],
  Trash: ["All", "Both", "Added", "Owned", "None"],
};

 const renderPopoverContent = (module) => {
  const isTaskModule = module.module_name === "Tasks";
  const isLimitedTaskAccess = module.module_name === "Limited Task Access";
    return (
      <div className="dropdown-checkboxes">
        {Object.keys(module.permissions).map((perm) => {
        const displayName =
          isLimitedTaskAccess && perm === "View"
            ? "Can give limited access"
            : perm;
        const hasDropdown =
          isTaskModule && TASK_PERMISSION_CONFIG[perm];

        // 🔹 TASK DROPDOWN
        if (hasDropdown) {
          return (
            <div key={perm} className="permission-dropdown" style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
              <span className="perm-label">{displayName}</span>

              <select
                style={{borderRadius: '3px', marginBottom:'2px', width: '70%'}}
                value={getTaskPermissionValue(
                  module.permissions[perm],
                  TASK_PERMISSION_CONFIG[perm]
                )}
                onChange={(e) => {
                  if (!canAccess(accessContext, "Security Control", "Edit")) {
                    message.error("Permission Denied");
                    return;
                  }

                  togglePermission(
                    module.module_id,
                    perm,
                    e.target.value
                  );
                }}
              >
                {TASK_PERMISSION_CONFIG[perm].map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          );
        }

        // 🔹 NORMAL CHECKBOX
        return (
          <label key={perm}>
            <Checkbox
              checked={!!module.permissions[perm]}
              onChange={() => {
                if(!canAccess(accessContext, "Security Control", "Edit")){
                  message.error("Permission Denied");
                  return
                }
                togglePermission(module.module_id, perm)
              }
              }
            >
              {displayName}
            </Checkbox>
          </label>
        )
      })}
      </div>
    );
  };

//  const renderPopoverContent = (module) => {
//   console.log("module:-",module)
//     return (
//       <div className="dropdown-checkboxes">
//         {Object.keys(module.permissions).map((perm) => (
//           <label key={perm}>
//             <Checkbox
//               checked={module.permissions[perm]}
//               onChange={() => {
//                 if(!canAccess(accessContext, "Security Control", "Edit")){
//                   message.error("Permission Denied");
//                   return
//                 }
//                 togglePermission(module.module_id, perm)
//               }
//               }
//             >
//               {perm.charAt(0).toUpperCase() + perm.slice(1)}
//             </Checkbox>
//           </label>
//         ))}
//       </div>
//     );
//   };
const syncUserPermissionToggle = (updatedPermissions) => {
  const hasAnyPermission =
    updatedPermissions?.ManageUsers?.enabled ||
    updatedPermissions?.["Manage Role"] ||
    updatedPermissions?.["Manage Profile"];

  setUserPermissionEnabled(hasAnyPermission);
  if (!hasAnyPermission) setUserDropdownOpen(false);
};

const renderUserPermissionsPopover = () => (
  <div className="dropdown-checkboxes">
    {Object.keys(userPermissions || {}).map((permKey) => {
      const permValue = userPermissions[permKey];

      // ManageUsers logic with scope
      if (permKey === "ManageUsers") {
        return (
          <div key={permKey} style={{ marginBottom: 8 }}>
            <label>
              <Checkbox
                checked={permValue.enabled}
                onChange={() => {
                  if (!canAccess(accessContext, "Security Control", "Edit")) {
                    message.error("Permission Denied");
                    return;
                  }

                  const isEnabled = !permValue.enabled;

                  const updated = {
                    ...userPermissions,
                    ManageUsers: {
                      enabled: isEnabled,
                      scope: {
                        "All Users": isEnabled ? true : false,
                        "Subordinate Only": false,
                      },
                    },
                  };

                  setUserPermissions(updated);
                  syncUserPermissionToggle(updated);
                  console.log("Updated user 2",updated)
                  const payload = {
                    ...isEditProfileAccess.Profile,
                    USER_PERMISSIONS: updated,
                    MODIFIEDBY: userInfo.email_id,
                  };
                  updateProfile(payload);
                }}
              >
                <strong>Manage Users</strong>
              </Checkbox>
            </label>

            {permValue.enabled && (
              <div style={{ marginLeft: 16, marginTop: 6 }}>
                {Object.entries(permValue.scope).map(([option, value]) => (
                  <label key={option} style={{ display: "block" }}>
                    <Checkbox
                      checked={value}
                      onChange={() => {
                        const updated = {
                          ...userPermissions,
                          ManageUsers: {
                            ...permValue,
                            scope: {
                              "All Users": option === "All Users",
                              "Subordinate Only":
                                option === "Subordinate Only",
                            },
                          },
                        };

                        setUserPermissions(updated);
                        syncUserPermissionToggle(updated);
                        console.log("Updated user 3",updated)
                        const payload = {
                          ...isEditProfileAccess.Profile,
                          USER_PERMISSIONS: updated,
                          MODIFIEDBY: userInfo.email_id,
                        };
                        updateProfile(payload);
                      }}
                    >
                      {option}
                    </Checkbox>
                  </label>
                ))}
              </div>
            )}
          </div>
        );
      }

      const isDisabled = disableRoleAndProfile && (permKey === "Manage Role" || permKey === "Manage Profile");

      return (
        <label
          key={permKey}
          style={{ display: "block", opacity: isDisabled ? 0.5 : 1 }}
        >
          <Checkbox
            checked={permValue}
            disabled={isDisabled}
            onChange={() => {
              if (!canAccess(accessContext, "Security Control", "Edit")) {
                message.error("Permission Denied");
                return;
              }

              const updated = { ...userPermissions, [permKey]: !permValue };
              setUserPermissions(updated);
              syncUserPermissionToggle(updated);
              console.log("Updated user 4",updated)
              const payload = {
                ...isEditProfileAccess.Profile,
                USER_PERMISSIONS: updated,
                MODIFIEDBY: userInfo.email_id,
              };
              updateProfile(payload);
            }}
          >
            {permKey}
          </Checkbox>
        </label>
      );
    })}
  </div>
);
  const renderSubModulePopoverContent = (sub, moduleId) => {
  const permissions = sub?.permissions || {};

  return (
    <div className="dropdown-checkboxes">
      {Object.keys(permissions).map((perm) => (
        <label key={perm}>
          <Checkbox
            checked={permissions[perm]}
            onChange={() => {
              if (!canAccess(accessContext, "Security Control", "Edit")) {
                message.error("Permission Denied");
                return;
              }
              toggleSubModulePermission(moduleId, sub.submodule_id, perm);
            }}
          >
            {perm.charAt(0).toUpperCase() + perm.slice(1)}
          </Checkbox>
        </label>
      ))}
    </div>
  );
};

const togglePermission = async (moduleId, permission, nextValue = null) => {debugger
    let updateFieldPermissions = [...(fieldPermissions || [])];
    let shouldRefresh = false;
    let isDeal;
    const updatedModules = modules.map((mod) => {
      if (mod.module_id !== moduleId) return mod;

      const isTask = mod.module_name === "Tasks";
      isDeal = mod.module_name === "Deals";
      const hasDropdown =
        isTask && TASK_PERMISSION_CONFIG[permission];

      let newValue;

      // ✅ TASK dropdown → always trust selected value
      if (hasDropdown && typeof nextValue === "string") {
        newValue = nextValue;
      }
      // ✅ normal checkbox
      else {
        newValue = !mod.permissions[permission];
      }

    const newPermissions = {
      ...mod.permissions,
        [permission]: newValue,
      };

      //  VIEW logic (dropdown + checkbox)
    if (permission === "View") {
      const isEnabled =
        hasDropdown ? newValue !== "None" : newValue === true;

      setModuleEnabled((prev) => ({
        ...prev,
        [moduleId]: isEnabled,
      }));

    if (!isEnabled) {
      setDropdownOpen((prev) => ({
        ...prev,
        [moduleId]: false,
      }));
    }
    }

    if(permission === "Edit" && isTask) {
      updateFieldPermissions = fieldPermissions?.map((item) => {
        if (
          item?.module_id !== moduleId ||
          item.module_name !== "Tasks"
        ) {
          return item;
        }
        return {
          ...item,
          fields: item?.fields?.map(field =>{
            if(field.permissions.Create === true) {
              shouldRefresh = true;
              return {
                ...field,
                permissions: {
                  ...field.permissions,
                  Create: false,
                  View: true
                }
              }
            }
            return field;
          }),
        };
      });
    }

    return { ...mod, permissions: newPermissions };
    })

    let finalModules = updatedModules;
    const dealModule = updatedModules.find(
      (m) => m.module_name === "Deals"
    );
    if(isDeal && permission === "View" && dealModule?.permissions?.View === false){
      finalModules = updatedModules.map((mod) => {
        if (mod.module_name !== "Tasks") return mod;

        const updatedPermissions = Object.keys(mod.permissions).reduce(
          (acc, perm) => {
            if (["View", "Edit", "Trash"].includes(perm)) {
              acc[perm] = "None";
            } else {
              acc[perm] = false;
            }
            return acc;
          },
          {}
        );

        return {
          ...mod,
          permissions: updatedPermissions,
        };
      });
    }
    setModules(finalModules);

    const payload = {
      ...isEditProfileAccess.Profile,
      MODULE_PERMISSIONS: finalModules,
      ...(shouldRefresh && {
        FIELD_PERMISSIONS: updateFieldPermissions,
      }),
      MODIFIEDBY  : userInfo.email_id
    };
    if(shouldRefresh){
      setFieldPermissions(updateFieldPermissions)
      setRefreshPermissions(prev => !prev);
    }
    try{
      if(fromUserForm){
        const payload = {
          ...isEditProfileAccess.Profile,
          IS_PERMISSION_OVERRIDEN: true,
          OVERRIDEN_MODULE_PERMISSION: finalModules,
          ...(shouldRefresh && {
            OVERRIDEN_FIELD_PERMISSION: updateFieldPermissions,
          }),
          MODIFIEDBY  : userInfo.email_id,
          ROWID : selectedUser?.ROWID
        };
        await updateUserProfile(payload);
      } else {
      await updateProfile(payload);
      }
    } catch(err){
      console.error("Update failed", err);
    } finally {
    }
};

// const togglePermission = async (moduleId, permission) => { 
//     let updateFieldPermissions = [...(fieldPermissions || [])];;
//     let shouldRefresh = false;
//     let updatedModule = modules.map((mod) => {
//       if (mod.module_id !== moduleId) return mod;
//     const newPermissions = {
//       ...mod.permissions,
//         [permission]: !mod.permissions[permission],
//       };

//       // If View is unchecked → disable module
//     if (permission === "View" && !newPermissions.View) {
//       setModuleEnabled((prev) => ({
//         ...prev,
//         [moduleId]: false,
//       }));
//       setDropdownOpen((prev) => ({
//         ...prev,
//         [moduleId]: false,
//       }));
//     }
//     if(permission == "Edit" && mod.module_name == "Tasks"){
      
//       updateFieldPermissions = fieldPermissions?.map(item =>{
//         if(item?.module_id != moduleId || item.module_name != "Tasks") {
//           return item;
//         }
//         return {
//           ...item,
//           fields: item?.fields?.map(field =>{
//             if(field.permissions.Create === true) {
//               shouldRefresh = true;
//               return {
//                 ...field,
//                 permissions: {
//                   ...field.permissions,
//                   Create: false,
//                   View: true
//                 }
//               }
//             }
//             return field;
//           })
//         }
//       })
//     }
//       // If View is checked → enable module
//       if (permission === "View" && newPermissions.View) {
//         setModuleEnabled((prev) => ({
//           ...prev,
//           [moduleId]: true,
//         }));
//       }
//       return {
//         ...mod, permissions: newPermissions,
//       };
//     })

//     setModules(updatedModule);

//     const payload = {
//       ...isEditProfileAccess.Profile,
//       MODULE_PERMISSIONS: updatedModule,
//       ...(shouldRefresh && {
//         FIELD_PERMISSIONS: updateFieldPermissions,
//       }),
//       MODIFIEDBY  : userInfo.email_id
//     };
//     if(shouldRefresh){
//       setFieldPermissions(updateFieldPermissions)
//       setRefreshPermissions(prev => !prev);
//     }
//     try{
//       await updateProfile(payload);
//     } catch(err){
//       console.error("Update failed", err);
//     } finally {
//     }
// };
const toggleUserPermissions = async () => {
  const isEnabled = userPermissionEnabled;

  const updated = { ...userPermissions };

  Object.keys(updated).forEach((key) => {
    if (key === "ManageUsers") {
      updated[key] = {
        enabled: !isEnabled,
        scope: {
          "All Users": !isEnabled,
          "Subordinate Only": false,
        },
      };
    } else {
      updated[key] = !isEnabled;
    }
  });

  setUserPermissions(updated);
  setUserPermissionEnabled(!isEnabled);
  console.log("Updated user 5",updated)
  const payload = {
    ...isEditProfileAccess.Profile,
    USER_PERMISSIONS: updated,
    MODIFIEDBY: userInfo.email_id,
  };
  // if(fromUserForm){
  //   const payload = {
  //     ...isEditProfileAccess.Profile,
  //     IS_PERMISSION_OVERRIDEN: true,
  //     OVERRIDEN_MODULE_PERMISSION: updatedModules,
  //     ...(shouldRefresh && {
  //       OVERRIDEN_FIELD_PERMISSION: updateFieldPermissions,
  //     }),
  //     MODIFIEDBY  : userInfo.email_id
  //   };
  //   await updateUserProfile(payload);
  // } else {
    await updateProfile(payload);
  // }

  if (isEnabled) setUserDropdownOpen(false);
};

const toggleSubModulePermission = async (moduleId, subModuleId, permission) => {

  let updatedModule = modules.map((mod) => {
    if (mod.module_id !== moduleId) return mod;

    const updatedSubModules = mod.sub_modules.map((sub) => {
      if (sub.submodule_id !== subModuleId) return sub;

      const newPermissions = {
        ...sub.permissions,
        [permission]: !sub.permissions[permission],
      };

      return {
        ...sub,
        permissions: newPermissions,
      };
    });

    return {
      ...mod,
      sub_modules: updatedSubModules,
    };
  });

  setModules(updatedModule);

  const payload = {
    ...isEditProfileAccess.Profile,
    MODULE_PERMISSIONS: updatedModule,
    MODIFIEDBY: userInfo.email_id,
  };
if(fromUserForm){
  const payload = {
    ...isEditProfileAccess.Profile,
    IS_PERMISSION_OVERRIDEN: true,
    OVERRIDEN_MODULE_PERMISSION: updatedModule,
    OVERRIDEN_FIELD_PERMISSION: fieldPermissions,
    MODIFIEDBY  : userInfo.email_id,
    ROWID : selectedUser?.ROWID
  };
  await updateUserProfile(payload);
} else {
  await updateProfile(payload);
}
};


const handleFieldPermissionChange = (target, fieldId, selectedPerm) => {debugger
  setFieldPermissions((prev) =>{
    const updatedModule = prev.map((module) => {

      if (target.type === "module" && module?.module_id === target?.id) {
      return {
        ...module,
        fields: module?.fields.map((field) =>
          field.field_id !== fieldId
            ? field
            : {
                ...field,
                permissions: {
                  View: selectedPerm === "View",
                  Create: selectedPerm === "Create",
                  DontShow: selectedPerm === "DontShow",
                },
              }
          ),
        };
      }

      if (target.type === "child_sub_module" && module?.sub_modules) {
          return {
          ...module,
          sub_modules: module?.sub_modules.map((sub) =>
            sub?.sub_module_id !== target.id
              ? sub
              : {
                  ...sub,
                  fields: sub.fields?.map((field) =>
                    field.field_id !== fieldId
                      ? field
                      : {
                          ...field,
                          permissions: {
                            View: selectedPerm === "View",
                            Create: selectedPerm === "Create",
                            DontShow: selectedPerm === "DontShow",
                          },
                        }
                  ),
                }
          ),
        };
      }
      if (target.type === "sub_module" && module?.sub_modules) {
          return {
          ...module,
          sub_modules: module?.sub_modules.map((sub) =>
            sub?.sub_module_id !== target.id
              ? sub
              : {
                  ...sub,
                  fields: sub.fields?.map((field) =>
                    field.field_id !== fieldId
                      ? field
                      : {
                          ...field,
                          permissions: {
                            View: selectedPerm === "View",
                            Create: selectedPerm === "Create",
                            DontShow: selectedPerm === "DontShow",
                          },
                        }
                  ),
                }
          ),
        };
      }
      return module;
    })
    setIsFieldChanged(true);
    setRefreshPermissions(prev => !prev);
    return updatedModule;
  }
  );
};
const isDealVisible = () =>{
  const perm = modules.filter((mod) =>mod.module_name === "Deals")[0].permissions;
  return perm["View"] === true;
}
const toggleModule = async (moduleId) => {debugger
  const isEnabled = moduleEnabled[moduleId];
  let isDeals;
      const updatedModule = modules.map((mod) =>{
        if (mod.module_id !== moduleId) return mod;

        const isTask = mod.module_name === "Tasks";
        isDeals = mod.module_name === "Deals";
        const updatedPermissions = Object.keys(mod.permissions).reduce(
          (acc, permission) => {
        // 🔹 TASK dropdown permissions
        if (isTask && TASK_PERMISSION_CONFIG[permission]) {
          console.log("isEnabled:-",isEnabled)
          acc[permission] = isEnabled ? "None" : "All";
        }
        else {
            acc[permission] = !isEnabled;
        }
            return acc;
          },
          {}
        );

        return {
          ...mod,
          permissions: updatedPermissions,
        };
        }
      )
      if (isDeals && isEnabled) {
        const newUpdatedModule = updatedModule.map((mod) => {
          if (mod.module_name !== "Tasks") return mod;

          const updatedPermissions = Object.keys(mod.permissions).reduce(
            (acc, permission) => {
              if (["View", "Edit", "Trash"].includes(permission)) {
                acc[permission] = "None";
              } else {
                acc[permission] = false;
              }
              return acc;
            },
            {}
          );

          return {
            ...mod,
            permissions: updatedPermissions,
          };
        });

        updatedModule.splice(0, updatedModule.length, ...newUpdatedModule);
      }
      setModules(updatedModule);
      const payload = {
        ...isEditProfileAccess.Profile,
        MODULE_PERMISSIONS: updatedModule,
        MODIFIEDBY  : userInfo.email_id
      };
      if(fromUserForm){
        const payload = {
          ...isEditProfileAccess.Profile,
          IS_PERMISSION_OVERRIDEN: true,
          OVERRIDEN_MODULE_PERMISSION: updatedModule,
          OVERRIDEN_FIELD_PERMISSION: fieldPermissions,
          MODIFIEDBY  : userInfo.email_id,
          ROWID : selectedUser?.ROWID
        };
        await updateUserProfile(payload);
      } else {
        await updateProfile(payload);
      }
      setModules(updatedModule);

    setModuleEnabled((prev) => ({
      ...prev,
      [moduleId]: !prev[moduleId],
    }));

    if (isEnabled) {
      setDropdownOpen((prev) => ({
        ...prev,
        [moduleId]: false,
      }));
    }
  };

// const toggleModule = (moduleId) => {
//   const isEnabled = moduleEnabled[moduleId];
//       let updatedModule = modules.map((mod) =>{
//         // mod.module_id === moduleId
//         //   ? {
//         //       ...mod,
//         //       permissions: {
//         //         View: !moduleEnabled[moduleId],
//         //         Create: !moduleEnabled[moduleId],
//         //         Edit: !moduleEnabled[moduleId],
//         //         Delete: !moduleEnabled[moduleId],
//         //       },
//         //     }
//         //   : mod
//         if(mod.module_id !== moduleId) return mod;
//         const updatedPermissions = Object.keys(mod.permissions).reduce(
//           (acc, permission) => {
//             acc[permission] = !isEnabled;
//             return acc;
//           },
//           {}
//         );
//         return {
//           ...mod,
//           permissions: updatedPermissions,
//         };
//         }
//       )
//       const payload = {
//         ...isEditProfileAccess.Profile,
//         MODULE_PERMISSIONS: updatedModule,
//         MODIFIEDBY  : userInfo.email_id
//       };
//       updateProfile(payload);
//       setModules(updatedModule);

//     setModuleEnabled((prev) => ({
//       ...prev,
//       [moduleId]: !prev[moduleId],
//     }));

//     if (moduleEnabled[moduleId]) {
//       setDropdownOpen((prev) => ({
//         ...prev,
//         [moduleId]: false,
//       }));
//     }

// };
const toggleSubModule = async (moduleId, subModuleId) => {
  let updatedModule = modules.map((mod) => {
    if (mod.module_id !== moduleId) return mod;

    const updatedSubModules = mod.sub_modules.map((sub) => {
      if (sub.submodule_id !== subModuleId) return sub;

      const isEnabled = Object.values(sub.permissions).some(Boolean);

      const updatedPermissions = Object.keys(sub.permissions).reduce(
        (acc, permission) => {
          acc[permission] = !isEnabled;
          return acc;
        },
        {}
      );

      return {
        ...sub,
        permissions: updatedPermissions,
      };
    });

    return {
      ...mod,
      sub_modules: updatedSubModules,
    };
  });

  const payload = {
    ...isEditProfileAccess.Profile,
    MODULE_PERMISSIONS: updatedModule,
    MODIFIEDBY: userInfo.email_id,
  };
  if(fromUserForm){
    const payload = {
      ...isEditProfileAccess.Profile,
      IS_PERMISSION_OVERRIDEN: true,
      OVERRIDEN_MODULE_PERMISSION: updatedModule,
      sOVERRIDEN_FIELD_PERMISSION: fieldPermissions,
      MODIFIEDBY  : userInfo.email_id,
      ROWID : selectedUser?.ROWID
    };
    await updateUserProfile(payload);
  } else {
    await updateProfile(payload);
  }
  setModules(updatedModule);
};

const [openFieldModules, setOpenFieldModules] = useState({});
const toggleFieldModule = (moduleId) => {
  setOpenFieldModules(prev => ({
    ...prev,
    [moduleId]: !prev[moduleId]
  }));
};

const getSubModules = (moduleId) => {
  const subModules = modulesList?.find(sub => sub.ROWID == moduleId)?.SUB_MODULES?.split(",").map(item => {
        const lastUnderscoreIndex = item.lastIndexOf("_");
        
        return {
          ROWID: Number(item.slice(lastUnderscoreIndex + 1)),
          MODULE_NAME: item.slice(0, lastUnderscoreIndex),
        };
      });
      
  return subModules;
};

const getChildSubModules = (subModuleId) => {
  const childSubModules = subModulesList?.find(sub => sub.ROWID == subModuleId)?.SUB_MODULES?.split(",").map(item => {
        const lastUnderscoreIndex = item.lastIndexOf("_");
        return {
          ROWID: Number(item.slice(lastUnderscoreIndex + 1)),
          MODULE_NAME: item.slice(0, lastUnderscoreIndex),
        };
      });
  return childSubModules;
};
const getFieldsBySelected = () => {
  if (!selectedFieldModule) return [];

  if (selectedFieldModule.type === "module") {
    return fieldPermissions?.find(
      m => m?.module_id === selectedFieldModule?.id
    )?.fields || [];
  }

  if (selectedFieldModule.type === "sub_module") {
    for (const module of fieldPermissions) {
      const sub = module?.sub_modules?.find(
        s => s.sub_module_id === selectedFieldModule.id
      );
      if (sub) return sub.fields || [];
    }
  }
  
  if (selectedFieldModule.type === "child_sub_module") {
    for (const module of fieldPermissions) {
      const sub = module?.sub_modules?.find(
        s => s.sub_module_id === selectedFieldModule.id
      );
      if (sub) return sub.fields || [];
    }
  }

  return [];
};

const [expandedModules, setExpandedModules] = useState({});

const toggleExpand = (moduleId) => {
  setExpandedModules(prev => ({
    ...prev,
    [moduleId]: !prev[moduleId]
  }));
};
const taskModule = modules?.find(
  mod => mod.module_name === "Tasks"
);

const isTaskEditDisabled = taskModule?.permissions?.Edit === false;

  return (
    <>
    <div className="profile-header">
      <Row>
        <Col sm={2} style={{display: 'flex',gap: '10px',alignItems: 'center', justifyContent: 'flex-start'}}>
     <FontAwesomeIcon icon={faArrowLeft} size={"sm"} color="#587654" cursor={"pointer"}
     onClick={()=>setIsEditProfileAccess({isTrue:false,Profile:{}})}/>  <Tooltip placement="bottom" title={isEditProfileAccess.Profile.PROFILE_NAME}><span className="Elipsis-Class" color= '#474545'>{isEditProfileAccess.Profile.PROFILE_NAME}</span></Tooltip>
     </Col> 
        <Col sm={2}>
           <div className="pos-relative" style={{ display: "flex", 
                 height: '2.2rem', marginTop: '2px', marginLeft: '-19px' }}>
             <div className="input-search-wrapper">
          <div className="search-icon-wrapper">
              <FontAwesomeIcon
                style={{padding:'2px'}}
                size="sm"
                color=" #646460"
                className="mr-sm-1 search-ico"
                icon={faSearch}
              />
              </div>
              </div>
          <Input
              type="text"
               value={searchTerm}
              onChange={(e) =>
                setSearchTerm(e.target.value)
              }
              placeholder="Search"
              className="mr-sm-2 pad-fix search-filter search-deal"
              style={{
                margin: '3px',
                width: "17rem",
                borderColor: "#018EE0",
              }}
            />
            </div>
            </Col>
               <Col sm={2}>
               {selectedTab === "field" && !fromUserForm && (
                <div className="basic-permissions-header">
                  <Select
                    placeholder="Select profile"
                    className="module-select-filter"
                    rootClassName="module-select-filter"
                    value={selectedProfileId}
                    onChange={(value) => setSelectedProfileId(value)}
                  >
                    {profilesData.map((profile) => (
                      <Option key={profile.ROWID} value={profile.ROWID}>
                        {profile.PROFILE_NAME}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}
               </Col>
               <Col sm={4}></Col>
               {fromUserForm && <Col sm={2} style={{textAlign: 'right', fontSize: 'smaller'}}>
               {selectedUser.first_name+' '+selectedUser.last_name}
               </Col>}
                </Row>
    </div>

    <div className={fromUserForm?"permissions-container-from-userform":"permissions-container"}>
      <div className="sidebar">
      {/* Module Permissions Tab */}
        <h4 className={selectedTab === "module" ? "active-tab" : ""}
          onClick={() => {
            setSelectedTab("module");
            setSelectedFieldModule(null); // reset selected module
          }}
        >
          Module Permissions
        </h4>
 
      {/* Field Permissions Tab */}
      <h4 className={selectedTab === "field" ? "active-tab" : ""}
        onClick={() => setSelectedTab("field")}
      >
        Field Permissions
      </h4>
      
      {/* Modules list under Field Permissions */}
      {selectedTab === "field" && (
        <ul className="field-module-list" style={{height: '76%', overflow: 'auto'}}>
          {modules.map((module) => {
              const subModules = getSubModules(module.module_id) || [];

            return (
              <li key={module.module_id}>
                <div className={`field-module-row ${module?.permissions?.View ? 'enabled-module' : 'disabled-module' }`} onClick={(e)=>{
                  e.preventDefault();
                  e.stopPropagation();
                  if(!module?.permissions?.View){
                    return
                  }
                  }}>
                  <Row sm={12}>
                  {/*Module name ALWAYS rendered */}
                  <Col sm={1}>
                  {subModules.length > 0 && (
                    <span
                      className="dropdown-arrow"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleFieldModule(module.module_id);
                      }}
                    >
                      <FontAwesomeIcon icon={openFieldModules[module.module_id] ?faCaretDown:faCaretRight}/>
                    </span>
                  )}
                  </Col>
                  <Col sm={10} style={{marginLeft:'-5px'}} className={
                            selectedFieldModule?.type === "module" && selectedFieldModule?.id === module.module_id
                              ? "active-module"
                              : selectedFieldModule?.type === "sub_module" &&
                                subModules.some(sub => sub.ROWID === selectedFieldModule?.id)
                        ? "active-module"
                        : ""
                    }>
                 <span 
                    onClick={() =>
                      setSelectedFieldModule({
                        type: "module",
                        id: module.module_id,
                        name: module?.module_name
                      })
                    }
                    title={module.module_name.trim()}
                    className={`Elipsis-Class`}
                  >
                    {module.module_name.trim()}
                  </span>
 
                  </Col>
                  </Row>
                  {/* Arrow ONLY if sub-modules exist */} 
                </div>

                {/* Sub-modules dropdown */}
                {/* {openFieldModules[module.module_id] &&
                  subModules.length > 0 && (
      <ul className="sub-module-list">
                      {subModules.map((sub) => (
                        <div
                          className={`field-module-row`}
                          key={sub.ROWID}
                          onClick={() =>
                            setSelectedFieldModule({ type: "sub_module", id: sub.ROWID })
                          }
                        >
                          <Row sm={12} style={{padding: '3px 0'}}>
                          <Col sm={2}>
                          </Col>
                          <Col sm={10} className={`${
                            selectedFieldModule?.type === "sub_module" &&
                            selectedFieldModule?.id === sub.ROWID
                              ? "active-sub-module"
                              : "subModuleClass"
                          }`}>
                          {sub.sub_module_name ?? sub.MODULE_NAME}
                            </Col>
                            </Row>
                        </div>
                      ))}
                    </ul>
                  )} */}
                {openFieldModules[module.module_id] &&
                  subModules.length > 0 && (
                    <ul className="sub-module-list">
                      {subModules.map((sub) => {
                        const childSubModules = getChildSubModules(sub.ROWID) || [];
                        
                        return (
                          <>
                          <div
                            className={`field-module-row`}
                            key={sub.ROWID}
                            onClick={() =>
                              setSelectedFieldModule({ type: "sub_module", id: sub.ROWID })
                            }
                          >
                            <Row sm={12} style={{ padding: '3px 0' }}>
                              <Col sm={1}>
                              </Col>
                              <Col sm={1}>
                                {/* Child sub-module dropdown arrow */}
                                {childSubModules.length > 0 && (
                                  <span
                                    className="dropdown-arrow"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleFieldModule(sub.ROWID);
                                    }}
                                  >
                                    <FontAwesomeIcon icon={openFieldModules[sub.ROWID] ? faCaretDown : faCaretRight} />
                                  </span>
                                )}
                              </Col>
                              <Col
                                sm={8}
                                title={sub.sub_module_name ?? sub.MODULE_NAME}
                                className={`Elipsis-Class ${
                                  selectedFieldModule?.type === "sub_module" &&
                                  selectedFieldModule?.id === sub.ROWID
                                    ? "active-sub-module"
                                    : "subModuleClass"
                                }`}
                              >
                                {sub.sub_module_name ?? sub.MODULE_NAME}
                              </Col>
                            </Row>

                            {/* Child sub-modules dropdown */} 
                          </div>
                          {openFieldModules[sub.ROWID] &&
                              childSubModules.length > 0 && (
                                <ul className="sub-module-list">
                                  {childSubModules.map((child) => (
                                    <div
                                      key={child.ROWID}
                                      className="field-module-row"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedFieldModule({
                                          type: "child_sub_module",
                                          id: child.ROWID
                                        });
                                      }}
                                    >
                                      <Row sm={12} style={{ padding: '3px 18px' }}>
                                        <Col sm={3}></Col>
                                        <Col
                                          sm={9}
                                          title={child.MODULE_NAME}
                                          className={`Elipsis-Class ${
                                            selectedFieldModule?.type === "child_sub_module" &&
                                            selectedFieldModule?.id === child.ROWID
                                              ? "active-sub-module"
                                              : "subModuleClass"
                                          }`}
                                        >
                                          {child.MODULE_NAME}
                                        </Col>
                                      </Row>
                                    </div>
                                  ))}
                                </ul>
                              )}
                          </>
                        );
                      })}
                    </ul>
                  )}
              </li>
            );
          })}
        </ul>
        )}
      {accessContext.profile.name === "Administrator" && 
      (
      <h4 className={selectedTab === "admin" ? "active-tab" : ""}
        onClick={() => setSelectedTab("admin")} 
      >
        Admin Level Permissions
      </h4>
    )}
      </div>

      <div className="content" style={fromUserForm?{height: "100%"}:{}}>
        {selectedTab === "admin" && (
          <div className="permissions-scroll">
            <div className="permission-row">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flexGrow: 1,
                }}
              >
                <span style={{ width: "16px" }} />

                <span className="module-name">User Permissions</span>

                <label className="switch">
                  <input
                    type="checkbox"
                    checked={userPermissionEnabled}
                    onChange={() => {
                      if (!canAccess(accessContext, "Security Control", "Edit")) {
                        message.error("Permission denied");
                        return;
                      }
                      toggleUserPermissions();
                    }}
                  />
                  <span className="slider"></span>
                </label>

                {userPermissionEnabled && (
                  <div className="actions">
                    <Popover
                      content={renderUserPermissionsPopover()}
                      trigger="click"
                      open={userDropdownOpen}
                      onOpenChange={() =>
                        setUserDropdownOpen((prev) => !prev)
                      }
                    >
                      <span>
                        {Object.entries(userPermissions || {})
                          .filter(([key, value]) =>
                            key === "ManageUsers" ? value.enabled : value
                          )
                          .map(([perm]) => perm)
                          .join(", ") || "No Permissions"}
                        &nbsp;
                        <FontAwesomeIcon icon={faAngleDown} />
                      </span>
                    </Popover>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {selectedTab === "module" && (<>
        <div className="basic-permissions-header"> 
        </div>
        <div className="permissions-scroll">
        {filteredModules
          .map((module) => {
        const hasSubModules = module.sub_modules?.length > 0;
        const isExpanded = expandedModules[module.module_id];

        return (
          <div key={module.module_id}>
            <div className="permission-row">
              <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                width:"99rem",
                flexGrow: 1,
                minWidth: 0, // prevent overflow
              }}>
              {/* Expand icon */}
              {hasSubModules ? (
                <span
                  onClick={() => {debugger
                  if(!canAccesSub(module.module_name) || !securityAccess(module.module_name, "Edit")){
                    message.error("Permission Denied")
                    return
                  }
                  toggleExpand(module.module_id)}}
                  style={{ cursor: "pointer", width:'1rem'}}
                >
                  <FontAwesomeIcon
                    icon={isExpanded ? faAngleDown : faAngleRight}
                  />
                </span>
              ) : (
                <span style={{ width: "1rem" }} />
              )}

              {/* Module name */}
            <span className="module-name">{module.module_name} </span>

            {/* Toggle switch */}
            <div className="WrapperForSwitchActions">
            <label className="switch">
              <input
                type="checkbox"
                checked={module.module_name === "Tasks"
                  ? module.permissions?.View && module.permissions.View !== "None"
                  : moduleEnabled[module.module_id]}
                onChange={() => {
                  if(!securityAccess(module.module_name, "Edit")){
                    message.error("Permission denied");
                    return
                  }
                  if(module.module_name == "Tasks" && !isDealVisible()){
                    message.error("Please enable Deals before enabling Tasks.")
                    return
                  }
                  toggleModule(module.module_id)}}
              />
              <span className="slider"></span>
            </label>

              {/* Module permissions */}
            {(moduleEnabled[module.module_id] ||
          (module.module_name === "Tasks" &&
            module.permissions?.View &&
            module.permissions.View !== "None")) && (
          <div className="actions">
            <Popover
              content={renderPopoverContent(module)}
              trigger={securityAccess(module.module_name, "Edit") ? "click" : []}
              open={dropdownOpen[module.module_id]}
              onOpenChange={() => {
                // if(!canAccess(accessContext, "Security Control", "Edit")){
                //   message.error("Permission Denied 3");
                //   return
                // }
                toggleDropdown(module.module_id)}
              }
            >
              {Object.entries(module.permissions).some(([_, value]) =>
                module.module_name === "Tasks" ? value && value !== "None" : value
              ) && (
              <span>
                {Object.entries(module.permissions)
                  .filter(([perm, value]) =>{
                    if(module.module_name === "Limited Task Access" && perm === "View"){
                      return value;
                    }
                    return module.module_name === "Tasks"
                      ? value && value !== "None" // show only selected for Tasks
                      : value
                  })
                  .map(([perm]) =>{
                    if(module.module_name === "Limited Task Access" && perm === "View") {
                      return "Can give limited access";
                    }
                    return perm
                  })
                  .join(", ")}
                &nbsp;<FontAwesomeIcon icon={faAngleDown} />
              </span>
              )}
            </Popover>
          </div>
        )}
        </div>
        {
          module?.module_name == "Deals" && (<SelectDealsModal isInitialRender={isInitialRender} onSelectedData={onSelectedData}
        selectedData={selectedData} setCriteriaModal={setCriteriaModal} view={"List"} criteriaModal={criteriaModal} allPipelineData={[]} modules={modules}/>)
        }
        </div>
        </div>

      {/* ================= SUBMODULE ROWS ================= */}
      {hasSubModules && isExpanded &&
        module.sub_modules.map((sub) => (
          <div
            key={sub.submodule_id}
            className="permission-row"
            style={{ paddingLeft: "1rem" }}
          >
            <div style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                flexGrow: 1,
                minWidth: 0, // prevent overflow
              }}>
            {/* Empty icon column */}
            <span style={{ width: "1rem" }} />

            {/* Submodule name */}
            <span className="module-name" style={{width:'28rem'}}>
              {sub.submodule_name}
            </span>

            {/* ✅ SUBMODULE TOGGLE */}
            <label className="switch">
              <input
                type="checkbox"
                checked={Object.values(sub.permissions).some(Boolean)}
                onChange={() => {
                  if (!canAccess(accessContext, "Security Control", "Edit")) {
                    message.error("Permission denied");
                    return;
                  }
                  toggleSubModule(module.module_id, sub.submodule_id);
                }}
              />
              <span className="slider"></span>
            </label>

            {/* Submodule permissions */}
            <div className="actions">
              <Popover
                content={renderSubModulePopoverContent(sub, module.module_id)}
                trigger="click"
                open={subDropdownOpen[sub.submodule_id]}
                onOpenChange={() => toggleSubDropdown(sub.submodule_id)}
              >
                <span>
                  {Object.entries(sub.permissions)
                    .filter(([_, value]) => value)
                    .map(([perm]) => perm)
                    .join(", ") || "No Permissions"}
                  &nbsp;<FontAwesomeIcon icon={faAngleDown} />
                </span>
              </Popover>
            </div>
          </div>
        </div>
        ))}
        </div>
        );
      })}
      </div>
    </>
  )}
        {selectedTab === "field" && (
          <>  
            <div className="field-permissions-header">
              <span>Fields</span>
              <span>Read & Write</span>
              <span>Read Only</span>
              <span>Don't Show</span>
            </div> 
        <div className="permissions-scroll">
          {selectedFieldModule ? (
            getFieldsBySelected().map((field, index) => (
              <div key={index} className="field-permissions-row">
                <span>{fieldList?.find(fi => fi?.ROWID == field?.field_id)?.FIELD_NAME}</span>
                {["Create", "View", "DontShow"].map((perm) => (
                  <label key={perm}>
                    <input
                      disabled = {selectedFieldModule?.name === "Tasks" && perm === "Create" && isTaskEditDisabled}
                      type="radio"
                      name={`field-${field.field_id}`}
                      checked={field.permissions[perm]}
                      onChange={() =>{
                        if(!canAccess(accessContext, "Security Control", "Edit")){
                          message.error("Permission Denied");
                          return
                        }
                        handleFieldPermissionChange(
                          selectedFieldModule,
                          field.field_id,
                          perm
                        )
                      }
                      }
                    />
                  </label>
                ))}
              </div>
            ))
          ) : (
            <div style={{ padding: "10px", color: "#6b7280" }}>
              Select a module or sub-module to see its fields
            </div>
          )}
        </div>
 
        {/* Buttons outside scroll */}
        <div className="field-permissions-actions">
          <button className="btn cancel-btn" onClick={() => setSelectedFieldModule(null)}>
            Cancel
          </button>
          <button className="btn save-btn" disabled={!isFieldChanged}
            onClick={async () => {
              setIsFieldChanged(false);
              const payload = {
                ...isEditProfileAccess.Profile,
                FIELD_PERMISSIONS: fieldPermissions,
                MODIFIEDBY  : userInfo.email_id
              };
              if(fromUserForm){
                const payload = {
                  ...isEditProfileAccess.Profile,
                  IS_PERMISSION_OVERRIDEN: true,
                  OVERRIDEN_FIELD_PERMISSION: fieldPermissions,
                  MODIFIEDBY  : userInfo.email_id,
                  ROWID : selectedUser?.ROWID
                };
                await updateUserProfile(payload);
              } else {
                await updateProfile(payload, true);
              }
              setTimeout(() => setSaveMessage(""), 3000);
            }}
          >
            Save
          </button>
            {saveMessage && (
              <div className="toast-popup">
                {saveMessage}
              </div>
            )}
        </div>
          </>
        )}
 
      </div>
    </div>
        </>
  );
}
